// src/chatbot/products.js
// src/chatbot/products.js
export const products = [
    {
        id: 1,
        name: 'Aqua Di Gio',
        price: 7.79,
        category: 'fresh',
        longevity: 'medium',
        occasion: 'office',
        gender: 'male',  // male
        image: 'images/product1.jpeg',
        description: 'Fresh • Aquatic • Refined',
        rating: 4.5
    },
    {
        id: 2,
        name: 'Oud Wood',
        price: 9.79,
        category: 'oud',
        longevity: 'long',
        occasion: 'evening',
        gender: 'male',  // male
        image: 'images/product2.jpeg',
        description: 'Deep • Earthy • Powerful',
        rating: 4.6
    },
    {
        id: 3,
        name: 'Imagination',
        price: 10.79,
        category: 'fresh',
        longevity: 'medium',
        occasion: 'casual',
        gender: 'unisex',  // unisex
        image: 'images/product3.jpeg',
        description: 'Inspired • Bold • Limitless',
        rating: 4.4
    },
    {
        id: 4,
        name: 'Angel Share',
        price: 15.79,
        category: 'sweet',
        longevity: 'long',
        occasion: 'special',
        gender: 'unisex',  // unisex
        image: 'images/product4.jpeg',
        description: 'Rich • Warm • Unforgettable',
        rating: 4.7
    },
    {
        id: 5,
        name: 'Royal Oud',
        price: 18.99,
        category: 'oud',
        longevity: 'very long',
        occasion: 'formal',
        gender: 'male',  // male
        image: 'images/product5.jpeg',
        description: 'Majestic • Woody • Intense',
        rating: 4.8
    },
    {
        id: 6,
        name: 'Musk Al Tahara',
        price: 12.49,
        category: 'fresh',
        longevity: 'long',
        occasion: 'everyday',
        gender: 'unisex',  // unisex (good for women too)
        image: 'images/product6.jpeg',
        description: 'Clean • Soft • Elegant',
        rating: 4.5
    },
    {
        id: 7,
        name: 'Bakhoor Malaki',
        price: 24.99,
        category: 'oud',
        longevity: 'very long',
        occasion: 'ceremonial',
        gender: 'unisex',  // unisex
        image: 'images/product1.jpeg',
        description: 'Smoky • Rich • Traditional',
        rating: 4.9
    },
    {
        id: 8,
        name: 'Amber Oud',
        price: 14.99,
        category: 'sweet',
        longevity: 'long',
        occasion: 'evening',
        gender: 'unisex',  // unisex
        image: 'images/product2.jpeg',
        description: 'Sweet • Warm • Addictive',
        rating: 4.6
    },
    {
        id: 9,
        name: 'Floral Dream',
        price: 13.99,
        category: 'floral',
        longevity: 'medium',
        occasion: 'casual',
        gender: 'female',  // female
        image: 'images/product3.jpeg',
        description: 'Delicate • Romantic • Elegant',
        rating: 4.4
    },
    {
        id: 10,
        name: 'Rose Oud',
        price: 16.99,
        category: 'floral',
        longevity: 'long',
        occasion: 'evening',
        gender: 'female',  // female
        image: 'images/product4.jpeg',
        description: 'Floral • Rich • Sophisticated',
        rating: 4.7
    }
];

export default products;